import {DragDropContext,Droppable,Draggable} from "react-beautiful-dnd";
import {useDropzone} from 'react-dropzone';
import styled from "styled-components";
import UploadImageAPI from "../../Utils/uploadImage";

const ContainerDropZone=styled.div`
margin:10px;
border:3px dashed;`;

const TextoDropZone=styled.p`
margin:0px;
padding:5% 10%;
text-align:center;`;

const UploadImage = ({ id,  setLoading, RefPath, OnUploadImage  }) => 
{


    const {getRootProps, getInputProps,isDragActive} = useDropzone({accept:"image/*", onDrop: async imagenes =>
    {
        setLoading(true);
        
        for (const imagenDrop of imagenes)
        {
            const ImagenSubida = await UploadImageAPI(imagenDrop);

            if(ImagenSubida.status!==200) return;

            await OnUploadImage(ImagenSubida.path);
        }

        setLoading(false);
    }});

    return <div>
        <ContainerDropZone {...getRootProps({className: 'dropzone'})}>
            <input {...getInputProps()} />
            {isDragActive ? <TextoDropZone>Suelta la imagen</TextoDropZone> : <TextoDropZone>Arrastrá o clickeá</TextoDropZone>}
        </ContainerDropZone>   
    </div>
}

export default UploadImage;